import { TreeItemIconBlock } from '../../../../../../components/checkbox-tree-view/custom-tree-item/tree-item-icon-block';
import { TreeItemLabelBlock } from '../../../../../../components/checkbox-tree-view/custom-tree-item/tree-item-label-block';
import { TreeItemMetadataBlock } from '../../../../../../components/checkbox-tree-view/custom-tree-item/tree-item-metadata-block';
import { TreeItemMetadataCount } from '../../../../../../components/checkbox-tree-view/custom-tree-item/tree-item-metadata-count';
import { Box, Checkbox } from '@mui/material';
import React, { memo, useCallback } from 'react';
import type { AutocompleteFilterOptionProps as Props } from './types';
import * as SX from './sx';

function AutocompleteFilterOptionComponent({
  item,
  checkboxPosition = 'left',
  checked,
  onToggle,
  multiSelect = true,
  iconSx,
  avartarFallbackIcon,
  metadataEnabled,
  metadataApiLoading,
}: Props) {
  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (item.disabled) return;
      onToggle();
    },
    [item.disabled, onToggle]
  );

  const handleCheckboxChange = useCallback(
    (_e: React.ChangeEvent<HTMLInputElement>) => {
      if (item.disabled) return;
      onToggle();
    },
    [item.disabled, onToggle]
  );

  const showCheckbox = multiSelect;
  const showCheckboxRight =
    showCheckbox && checkboxPosition === 'right' && !item.metadata?.comingSoon;
  const showCheckboxLeft = showCheckbox && checkboxPosition === 'left';

  return (
    <Box
      className="AutocompleteFilterOption"
      sx={SX.root}
      onClick={handleClick}
      onMouseDown={(e) => e.preventDefault()}
    >
      {showCheckboxLeft && (
        <Checkbox
          size="small"
          checked={checked}
          disabled={item.disabled}
          onChange={handleCheckboxChange}
          onClick={(e) => e.stopPropagation()}
          sx={SX.checkboxLeftSx}
        />
      )}
      <TreeItemIconBlock
        icon={
          typeof item.metadata?.icon === 'string'
            ? item.metadata.icon
            : undefined
        }
        logoUrl={item.metadata?.logo_url}
        iconSx={iconSx}
        avartarFallbackIcon={avartarFallbackIcon}
      />
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        flex={1}
        minWidth={0}
      >
        <TreeItemLabelBlock item={item} />
        <TreeItemMetadataBlock item={item} />
      </Box>
      <TreeItemMetadataCount
        item={item}
        metadataEnabled={metadataEnabled}
        metadataApiLoading={metadataApiLoading}
      />
      {showCheckboxRight && (
        <Checkbox
          size="small"
          checked={checked}
          disabled={item.disabled}
          onChange={handleCheckboxChange}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </Box>
  );
}

AutocompleteFilterOptionComponent.displayName = 'AutocompleteFilterOption';

export const AutocompleteFilterOption = memo(AutocompleteFilterOptionComponent);
